import React from 'react';
export default class CustomButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: false };
    }
    onClickHandler(event) {
        if (!this.props.action) {
            console.error('Must define a click handler for button');
        } else {
            if (!this.state.isLoading) {
                //callclickhadler
                this.props.action(this);
                console.log('NOT LOADING NOW');
            } else {
                console.log('Already LOADING NOW');
            }
        }
    }
    onLoading() {
        this.setState({ isLoading: true });
    }
    onLoaded() {
        this.setState({ isLoading: false });
    }
    render() {
        return (
            <button
                className={this.props.className}
                ref={this.props.customRef}
                style={this.props.style || {}}
                type={this.props.type}
                onClick={this.onClickHandler.bind(this)}
            >
                {this.props.children}
                {this.state.isLoading && (
                    <div className="loading-wheel-container">
                        <div className="loading-wheel" />
                    </div>
                )}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/common/components/CustomButton.jsx